export default __webpack_public_path__ + "static/media/show-your-talent.b2676040.png";